export function logoutHandler(logout: any) {
  logout("https://shopping.sicredi.com.br/login-parcerias");
}
